<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Acción de Jugada" />

    <RepositoryType />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import RepositoryType from "@/components/Pages/Admin/Repository/view.vue";

export default defineComponent({
  name: "CreateRepositoryPage",
  components: {
    PageTitle,
    RepositoryType,
  },
});
</script>
